import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-add-svg',
  standalone: true,
  imports: [],
  template: `<svg
    [attr.width]="width"
    [attr.height]="height"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.6665 11.3334H0.666504V8.66675H8.6665V0.666748H11.3332V8.66675H19.3332V11.3334H11.3332V19.3334H8.6665V11.3334Z"
      fill="#1C1D1F"
    />
  </svg> `,
  styles: ``,
})
export class AddSvgComponent {
  @Input() width?: string = '20px';
  @Input() height?: string = '20px';
}
